import {
    buildComponentSlice,
    useComponentSlice,
    WidgetComponentSliceActionPayloadType,
} from 'widgets/store/component/componentSlice';

import { WidgetType } from 'widgets/WidgetType';
import {
    initialPortfolioReturnsComponentState,
    PortfolioReturnsComponentState,
} from 'widgets/portfolioReturns/store/component/PortfolioReturnsComponentState';
import { selectPortfolioReturnsState } from 'widgets/portfolioReturns/store/selectors';

export const buildPortfolioReturnsComponentSlice = () =>
    buildComponentSlice<PortfolioReturnsComponentState>(
        WidgetType.PORTFOLIO_RETURNS,
        selectPortfolioReturnsState,
        initialPortfolioReturnsComponentState
    );

export const usePortfolioReturnsComponentSlice = () =>
    useComponentSlice(buildPortfolioReturnsComponentSlice());

export type PortfolioReturnsComponentPayloadType =
    WidgetComponentSliceActionPayloadType<PortfolioReturnsComponentState>;
